import { Can } from '@oliasoft/authorization-ui';
import T from 'prop-types';
import { FaPhone, FaUsers } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import { Button, Column, Divider, Row, Spacer } from '@oliasoft-open-source/react-ui-library';

const renderNameWithTitle = ({ lastName, firstName, title }) => {
  const prefix = title ? `${title}. ` : '';
  return `${prefix}${lastName} ${firstName}`;
};

const iconStyle = { margin: '0 5px -3px 0' };

const UserInfo = ({ onUserChange, onUserEdit, canEdit = {}, canChange, onUnassignRole, user: { lastName, firstName, title, phone, email } }) => {
  return (
    <Row wrap>
      <Column flex width="100%">
        <FaUsers style={iconStyle} /> {renderNameWithTitle({ lastName, firstName, title })}
      </Column>
      <Divider margin="5px" />
      <Column flex width="100%">
        <IoMdMail style={iconStyle}  /> <a href={`mailto: ${email}`}>{email}</a>
      </Column>
      <Divider margin="5px" />
      <Column flex width="100%">
        <FaPhone style={iconStyle}/> {phone || 'n/a'}
      </Column>
      <Divider margin="5px" />
      <Column width="100%">
          <Row>
        <Can do={canChange.action} on={canChange.subject}>
          <Button colored onClick={onUserChange} label="Change" small />
          <Spacer width="5px" />
           <Button colored onClick={onUnassignRole} label="Remove role" small />
        </Can>
        {canEdit && canEdit.subject && (
          <Can do={canEdit.action} on={canEdit.subject}>
            <Spacer width="5px" />
            <Button colored onClick={onUserEdit} label="Edit" small />
          </Can>
        )}
        </Row>
      </Column>
    </Row>
  );
};

UserInfo.propTypes = {
  onUserChange: T.func.isRequired,
  onUserEdit: T.func.isRequired,
  onUnassignRole: T.func.isRequired,
  canChange: T.object.isRequired,
  user: T.shape({
    lastName: T.string.isRequired,
    firstName: T.string.isRequired,
    title: T.string,
    phone: T.string,
    email: T.string.isRequired,
  }).isRequired,
  canEdit: T.object,
};

export default UserInfo;
